import React from 'react'
import styled from 'styled-components'
import { Input } from 'sutra/components/Input/Input'
import { Select } from 'sutra/components/Select/Select'

import { FormikType } from 'features/project-form/features/source/components/NewSource'
import {
  amazonDomains,
  amazonOptions,
} from 'features/project-form/features/source/components/sources/AmazonOptions'
import { retrievePureUrl } from 'features/project-form/features/source/utils'

type Props = {
  formik: FormikType
  sourceAmazon: string
  sourceUrlValue?: string
}

export const AmazonUrlInput: React.FC<Props> = ({
  formik,
  sourceAmazon,
  sourceUrlValue,
}) => {
  const amazonFilterOptions = (
    <AmazonFilterSelect
      value={sourceAmazon}
      onChange={(option) => {
        if (formik.values.sourceUrl) {
          formik.setFieldValue(
            'sourceUrl',
            formik.values.sourceUrl.replace(sourceAmazon, option),
          )
        } else {
          formik.setFieldValue('sourceUrl', option)
        }
      }}
      options={amazonOptions}
    />
  )

  return (
    <DomainRow>
      {amazonFilterOptions}
      <Input
        name="sourceUrl"
        value={sourceUrlValue}
        onChange={(event) => {
          if (!event.target.value) {
            formik.setFieldValue('sourceUrl', sourceAmazon)
          } else {
            const targetDomain = retrievePureUrl(event.target.value)
            const amazonDomain = amazonDomains.find(
              (country_domain) =>
                targetDomain.indexOf(retrievePureUrl(country_domain)) !== -1,
            )
            formik.setFieldValue(
              'sourceUrl',
              amazonDomain
                ? amazonDomain +
                    targetDomain.replace(retrievePureUrl(amazonDomain), '')
                : sourceAmazon + event.target.value,
            )
          }
        }}
      />
    </DomainRow>
  )
}

// The marketplace picker sits beside the URL input and keeps a floor width.
export const AmazonFilterSelect = styled(Select)`
  flex: none;
  width: auto;
  min-width: 170px;
` as typeof Select

// Replaces antd's Input `addonBefore`: the domain Select sits beside the Input.
const DomainRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
